import React, { useState, useEffect } from 'react'
import NavbarUser from '../../components/navbar/NavbarUser'
import { GridToolbar } from '@mui/x-data-grid';
import AppDataGrid from '../../components/datatable/AppDataGrid';
import { columns } from './component/approvedbygroup/columnapprovelist';
import PopUpRecallGroup from './component/newDocument/popupcomponent/PopUpRecallGroup';
import FetchApi from '../customhooks/Functionapi';
import { useDemoData } from '@mui/x-data-grid-generator';
import Paper from '@mui/material/Paper';
import InputBase from '@mui/material/InputBase';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import SearchIcon from '@mui/icons-material/Search';
import Box from '@mui/material/Box';
import VerifiedUserRoundedIcon from '@mui/icons-material/VerifiedUserRounded';
import PageHeader from '../../components/pageheader/PageHeader';
import AppsRoundedIcon from '@mui/icons-material/AppsRounded';
import PendingActionsRoundedIcon from '@mui/icons-material/PendingActionsRounded';
import HighlightOffRoundedIcon from '@mui/icons-material/HighlightOffRounded';

const JournalHistory = () => {
  const userId = sessionStorage.getItem('userId');

  const { data, loading } = useDemoData({
    dataSet: 'Commodity',
    rowLength: 10,
    maxColumns: 6,
  });

  const FetchApis = new FetchApi();
  const [datalist, setDatalist] = useState([])
  const [dataAll, setDataAll] = useState([])
  const [datalisttotol, setDatalisttotal] = useState(0);

  const [totalreject, setTotalreject] = useState(0);
  const [checkTypeUser, setCheckTypeUser] = useState("");
  const [activeTab, setActiveTab] = useState('');

  useEffect(() => {
    getCheckStatustApproved();
    getJournalHistorylist()
    getJournalReject();
  }, [])

  const getJournalHistorylist = async () => {
    await FetchApis.FethcGet(`/JournalBygroup/journalgroupByid/${userId}`).then(res => {

      if (res.status == 200) {


        setDatalisttotal(res.data.length)
        setDatalist(res.data);
        setDataAll(res.data);
      }

    })
  }


  const getJournalReject = async () => {
    await FetchApis.FethcGet(`/JournalBygroup/journalRejectGroupByid/${userId}`).then(res => {

      if (res.status == 200) {

        setTotalreject(res.data.length)
        setDatalist(res.data);
        setDataAll(res.data);
      }

    })
  }

  const getJournalAll = async () => {
    await FetchApis.FethcGet(`/JournalBygroup/journalgrouplistByid/${userId}`).then(res => {

      if (res.status == 200) {

        setDatalist(res.data);
        setDataAll(res.data);
      }

    })
  }

  const getCheckStatustApproved = async () => {
    await FetchApis.FethcGet(`/JournalBygroup/journalgrouplistByid/${userId}`).then(res => {
      if (res.status == 200) {
        console.log(res.data[0])
        if (res.data.length > 0) {
          setCheckTypeUser(res.data[0].usertypestatus)
        }

      }

    })
  }



  function getRowId(row) {
    return row.groupId;
  }

  const filterBySearch = (event) => {

    const query = event.target.value;

    const filteredData = dataAll.filter(item => {
      return Object.values(item)
        .join('')
        .toLowerCase()
        .includes(query.toLowerCase());
    });

    setDatalist(filteredData);
  };


  return (
    <div>
      <NavbarUser />
      <main className="container mx-auto px-4 py-8" style={{ padding: 10, backgroundColor: '#f7f7f7' }}>
        <PageHeader
          title="Approved Group List All"
          subtitle="Manage document search journal list"
          icon={VerifiedUserRoundedIcon}
          color="#d81b60"
          gradient="linear-gradient(135deg, #d81b60 0%, #8e24aa 100%)"
          count={datalist.length}
          onSearch={(e) => filterBySearch(e)}
        >
            {[
              { key: 'all', label: 'เอกสารทั้งหมด', icon: <AppsRoundedIcon />, onClick: getJournalAll, color: '#455a64' },
              { key: 'revise', label: 'รายการเอกสาร Revise รออนุมัติ', icon: <PendingActionsRoundedIcon />, onClick: getJournalHistorylist, color: '#1e88e5', count: datalisttotol },
              { key: 'reject', label: 'รายการเอกสาร Reject', icon: <HighlightOffRoundedIcon />, onClick: getJournalReject, color: '#e53935', count: totalreject },
            ].map((btn) => {
              const active = activeTab === btn.key;
              return (
                <Button
                  key={btn.key}
                  onClick={() => { setActiveTab(btn.key); btn.onClick(); }}
                  startIcon={btn.icon}
                  sx={{
                    borderRadius: 999, px: 2, py: 0.85,
                    textTransform: 'none', fontWeight: 600, fontSize: 13.5,
                    color: active ? '#fff' : btn.color,
                    bgcolor: active ? btn.color : `${btn.color}12`,
                    border: `1px solid ${active ? btn.color : `${btn.color}33`}`,
                    boxShadow: active ? `0 4px 12px ${btn.color}40` : 'none',
                    transition: 'all .15s',
                    '&:hover': { bgcolor: active ? btn.color : `${btn.color}22` },
                  }}
                >
                  {btn.label}
                  {btn.count > 0 && (
                    <Box component="span" sx={{
                      ml: 1, minWidth: 22, height: 20, px: 0.75, borderRadius: 999,
                      display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                      fontSize: 11.5, fontWeight: 700,
                      bgcolor: active ? '#fff' : '#e53935',
                      color: active ? btn.color : '#fff',
                    }}>
                      {btn.count > 99 ? '99+' : btn.count}
                    </Box>
                  )}
                </Button>
              );
            })}
            {checkTypeUser == '100' && (
              <Box sx={{ ml: 'auto' }}>
                <PopUpRecallGroup userId={userId} />
              </Box>
            )}
        </PageHeader>
        <div>

          <div style={{ marginTop: 20 }}>
            <AppDataGrid
              rows={datalist}
              getRowId={getRowId}
              columns={columns}
              loading={loading}
              slots={{ toolbar: GridToolbar }}
              initialState={{
                pagination: {
                  paginationModel: {
                    pageSize: 25,
                  },
                },
              }}
              pageSizeOptions={[10, 25, 50, 100]}
            />

          </div>
          {/* </Container> */}
        </div>
      </main>
    </div>
  )
}

export default JournalHistory